import { withDevice } from '~/features/App/Device';

import { SimpleCard as SMPLCC } from './SimpleCard';

const enhance = withDevice;

export const SimpleCard = enhance(SMPLCC);
